import React from "react";
import CalculatorPage from "./CalculatorPage";

const CalculatorApp: React.FC = () => {
  return <CalculatorPage />;
};

export default CalculatorApp;

